export default {
  title: 'Moje objednávky',
  subtitle: 'Sledujte doručení, zobrazujte klíče a stahujte faktury.',

  filter: {
    aria: 'Filtrovat objednávky',
    all: 'Vše',
    keys: 'Klíče',
    topups: 'Dobití',
  },

  table: {
    item: 'Položka',
    date: 'Datum',
    status: 'Stav',
    amount: 'Částka',
    actions: 'Akce',
  },

  noMatch: 'Pro tento filtr zde nic není.',

  empty: {
    title: 'Zatím žádné objednávky.',
    body: 'Jakmile provedete objednávku, vaše nákupy se zde zobrazí se stavem doručení a možností zobrazit klíče.',
    cta: 'Procházet katalog',
  },

  row: {
    qty: '{n} ks',
    wallet: 'Peněženka',
    walletTopup: 'Dobití peněženky',
    viewOrder: 'Zobrazit objednávku',
    downloadReceipt: 'Faktura PDF',
  },

  detail: {
    invoiceNote: 'Zaplaceno z peněženky. Faktura patří k dobití, ze kterého byla objednávka uhrazena:',
    invoiceLink: 'Platby › Faktury',
    title: 'Objednávka {ref}',
    notFound: 'Objednávka nenalezena',

    keys: {
      title: 'Vaše klíče',
      encrypted: 'Klíče jsou uloženy šifrovaně. Klikněte na „Zobrazit klíče“ — váš přístup bude zaznamenán.',
      reveal: 'Zobrazit klíče',
    },

    note: {
      PENDING: 'Objednávka se zpracovává. Tato stránka se aktualizuje automaticky.',
      FAILED: 'Objednávku se nepodařilo dokončit.',
      REFUNDED: 'Za tuto objednávku byly vráceny peníze.',
    },

    totals: {
      unitPrice: 'Cena za kus',
      quantity: 'Množství',
      total: 'Celkem',
    },

    timeline: {
      title: 'Průběh objednávky',
    },
  },
};
